import { ExternalTemplateInformation } from ".";

export class ExternalTemplatesInformation {
  isComplete: boolean;
  templates: ExternalTemplateInformation[];
}
